import { render, staticRenderFns } from "./SystemConfigPage.vue?vue&type=template&id=498c92a8&"
import script from "./SystemConfigPage.vue?vue&type=script&lang=js&"
export * from "./SystemConfigPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports